export const DISPATCH_ALERT_CAPTURE_STATUS_EVENT = "grain:dispatch-alert-capture-status";
export const REASSIGNMENT_DIAGNOSTICS_STATUS_EVENT = "grain:reassignment-diagnostics-status";
export const DISPATCH_CAPTURE_ARRIVAL_EVENT = "grain:dispatch-capture-arrival";

function publishStatus(eventName, isActive) {
  if (typeof window === "undefined" || typeof window.dispatchEvent !== "function") {
    return;
  }

  const detail = { isActive: isActive === true };
  if (typeof CustomEvent === "function") {
    window.dispatchEvent(new CustomEvent(eventName, { detail }));
    return;
  }

  window.dispatchEvent(new Event(eventName));
}

export function publishDispatchAlertCaptureStatus(isActive) {
  publishStatus(DISPATCH_ALERT_CAPTURE_STATUS_EVENT, isActive);
}

export function publishReassignmentDiagnosticsStatus(isActive) {
  publishStatus(REASSIGNMENT_DIAGNOSTICS_STATUS_EVENT, isActive);
}

export function subscribeDispatchCaptureStatus(eventName, listener) {
  if (
    typeof window === "undefined"
    || typeof window.addEventListener !== "function"
    || typeof listener !== "function"
  ) {
    return () => {};
  }

  const handleEvent = (event) => {
    listener(event?.detail?.isActive === true);
  };
  window.addEventListener(eventName, handleEvent);
  return () => {
    window.removeEventListener(eventName, handleEvent);
  };
}

function isCaptureArrivalView(view) {
  return view === "errors" || view === "reassignment" || view === "source_changes" || view === "consolidation" || view === "reports" || view === "journal";
}

export function publishDispatchCaptureArrival(view) {
  if (typeof window === "undefined" || typeof window.dispatchEvent !== "function" || !isCaptureArrivalView(view)) {
    return;
  }

  const detail = { view };
  if (typeof CustomEvent === "function") {
    window.dispatchEvent(new CustomEvent(DISPATCH_CAPTURE_ARRIVAL_EVENT, { detail }));
    return;
  }

  window.dispatchEvent(new Event(DISPATCH_CAPTURE_ARRIVAL_EVENT));
}

export function subscribeDispatchCaptureArrival(listener) {
  if (
    typeof window === "undefined"
    || typeof window.addEventListener !== "function"
    || typeof listener !== "function"
  ) {
    return () => {};
  }

  const handleEvent = (event) => {
    const view = event?.detail?.view;
    if (isCaptureArrivalView(view)) {
      listener(view);
    }
  };
  window.addEventListener(DISPATCH_CAPTURE_ARRIVAL_EVENT, handleEvent);
  return () => {
    window.removeEventListener(DISPATCH_CAPTURE_ARRIVAL_EVENT, handleEvent);
  };
}
